import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import toast from "react-simple-toasts";
import styled from "styled-components";
import { ButtonInput, SmartInput } from "../../Components/reusable_components";
import Universe from "../../Components/Universe";
import { ToastTimer } from "../../data";
import { auth, fireStoredb } from "../../firebase_config";
const SlideBtn = styled.span`
  width: 45px;
  height: 25px;
  border: 1px solid #693b93;
  margin: 10px;
  position: relative;
  display: inline-block;

  ::before {
    content: "";
    width: 50%;
    height: 110%;
    background-color: #24093d;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${(props) => (props.toogle ? "50%" : "0%")};
    border: 2px groove #693b93;
    cursor: pointer;
    transition: 0.5s all ease-in-out;
  }
`;
const Login = () => {
  const [disabled, setdisabled] = useState(false);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [username, setusername] = useState("");
  const [passwordHide, setpasswordHide] = useState(true);
  const [toogle, settoogle] = useState(false);

  const handleSubmit = async () => {
    if (email === "" || password === "" || (toogle && username === "")) {
      return toast("Required fields..", 1000);
    }
    setdisabled(true);
    if (!toogle) {
      // login section
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          toast(user.email, { time: ToastTimer, position: "top-center" });
          window.location.replace("/");
        })
        .catch((error) => {
          toast("Invalid Credentials", ToastTimer);
        });
    } else {
      createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          let num = Math.floor(Math.random() * 11) + 1;
          setDoc(doc(fireStoredb, "user", user.uid), {
            email: email,
            username: username,
            avatar: `./assets/avatar/Screenshot_${num}.png`,
            admin: false,
          })
            .then((res) => {
              toast("Data store successfully", ToastTimer);
            })
            .catch((err) => {
              console.log(err);
              toast("Something went wrong", ToastTimer);
            });
          toast(user.email, { time: ToastTimer, position: "top-center" });
        })
        .catch((error) => {
          toast("Email already Registered", ToastTimer);
        });
    }

    setTimeout(() => {
      setdisabled(false);
    }, 2000);
  };
  return (
    <div style={{ marginBottom: "20px" }}>
      <Universe />
      <div style={{ width: "273px", margin: "auto", color: "#fff" }}>
        <div>
          <SlideBtn
            onClick={() => settoogle(toogle ? false : true)}
            toogle={toogle}
          ></SlideBtn>
          <span style={{ fontSize: "12px" }}>
            Toggle here for SignUp or Login
          </span>
        </div>
        <SmartInput
          type="email"
          placeholder="Type Your Email"
          onChange={(e) => setemail(e.target.value)}
        />
        {toogle && (
          <SmartInput
            type="text"
            placeholder="Type Your username"
            onChange={(e) => setusername(e.target.value)}
          />
        )}
        <div>
          <SmartInput
            type={passwordHide ? "password" : "text"}
            placeholder="Type Your Password"
            onChange={(e) => setpassword(e.target.value)}
          />
          <span onClick={() => setpasswordHide(passwordHide ? false : true)}>
            {password.length > 0 && (passwordHide ? <FaEyeSlash /> : <FaEye />)}
          </span>
        </div>
        <ButtonInput
          value={toogle ? "Sign up" : "Log In"}
          onClick={handleSubmit}
          disabled={disabled}
        />
        <br />

        <p>Forget password</p>
      </div>
    </div>
  );
};

export default Login;
